import { Controller } from "@hotwired/stimulus"
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = [ "modal" ]

  connect() {
    let element = document.getElementById("turbo-modal");
    var modal = new Modal(element);
    modal.show();
  }

  show(event) {
  }

  hide(event) {

  }
}